import { WebLocale } from '@/enums/web-locale';
import { isBot } from '@/helpers/bot-helper';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

const platform = 'webapp';

// STATE
const state = () => ({
	/**
	 * whether constants and router has been loaded.
	 */
	errorCode: 0,
	errorObject: {},
	errorStatus: false,
	isBot: isBot(),
	geoLocation: null as WebLocale | null,
	platform: platform,
	seoUser: false,
	version: process.env.VERSION,
});

export type AppState = ReturnType<typeof state>;

// GETTERS
const getters: GetterTree<AppState, any> = {
	hasError(state): boolean {
		return state.errorStatus;
	},

	getError(state): any {
		return state.errorObject;
	},

	getErrorCode(state): number {
		return state.errorCode;
	},

	isSeoUser(state): boolean {
		return state.seoUser;
	},
};

// ACTIONS
const actions: ActionTree<AppState, any> = {
	setError({ commit }, err: {}) {
		commit('SET_ERROR_STATUS', true);
		commit('SET_ERROR_OBJECT', err);
	},
	setGeoLocation({ commit }, locale: WebLocale) {
		commit('SET_GEO_LOCATION', locale);
	},
	setSeoUser({ commit }, value: boolean) {
		commit('SET_SEO_USER', value);
	},
};

// MUTATIONS
const mutations: MutationTree<AppState> = {
	SET_ERROR_CODE(state, code: number) {
		state.errorCode = code;
	},
	SET_ERROR_OBJECT(state, object: number) {
		state.errorObject = object;
	},
	SET_ERROR_STATUS(state, status: boolean) {
		state.errorStatus = status;
	},
	SET_GEO_LOCATION(state, locale: WebLocale) {
		state.geoLocation = locale;
	},
	SET_SEO_USER(state, value: boolean) {
		state.seoUser = value;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
} as Module<AppState, any>;
